import { handleDeleteConfirmation } from '@helpers/handleDeleteConfirmation'
import { types } from "@redux/types/types"
import { listFilter } from '../../../utility/helpers/Axios/listFilter'
import { serverRequest } from '../../../utility/helpers/Axios/serverRequest'
import { Slide, toast } from 'react-toastify'
import { Fragment } from 'react'
import { Coffee } from 'react-feather'
import Avatar from '@components/avatar'
import { CToast } from '../../../views/addons/ToastMessage'

const ToastContent = ({ title, color, message }) => (
    <Fragment>
        <div className='toastify-header'>
            <div className='title-wrapper'>
                <Avatar size='sm' color={color} icon={<Coffee size={12} />} />
                <h6 className='toast-title font-weight-bold'>{title}</h6>
            </div>
        </div>
        <div className='toastify-body'>
            <span>{message}</span>
        </div>
    </Fragment>
)

export const cleaningAll = () => ({
    type: types.cleaningAll
})

export const setData = (endPoint, data) => ({
    type: types.load,
    payload: {
        data,
        endPoint
    }
})

export const startLoadingTable = (endPoint, filter = null, params = {}, method = 'GET') => {
    return async (dispatch) => {
        dispatch({ type: types.cleaningAll })
        const data = await serverRequest(endPoint, null, { filter, ...params }, method, false, true)
        if (!!data) dispatch(setData(endPoint, data))
    }
}

export const deleteRegister = (id) => ({
    type: types.delete,
    payload: id
})

export const startDeleteRegister = (id, end = null, callback = null) => {
    return async (dispatch, getState) => {
        const endPoint = end !== null ? end : getState().list.endPoint
        const respuesta = await handleDeleteConfirmation()
        if (!!respuesta) {
            const success = await serverRequest(endPoint, id, {}, 'DELETE')
            if (success !== undefined) {
                dispatch(deleteRegister(id))
                if (callback) dispatch(callback)
            } else CToast({ title: 'Conflicto de Datos', message: 'Este registro tiene datos relacionados. No se puede eliminar' })
        }
    }
}

export const handleChange = (valor, name, index) => {

    return async (dispatch) => {
        dispatch({
            type: types.change,
            payload: {
                valor,
                name,
                index
            }
        })
    }
}

export const startLoadingTableFilter = (endPoint, form) => {

    return async (dispatch) => {
        dispatch(cleaningAll())

        const data = await listFilter(endPoint, form)

        dispatch(setData(data.data.data, endPoint))
    }
}

export const halfload = (objective, parentId) => {
    return async (dispatch) => {
        const { details } = await serverRequest('route', parentId)
        dispatch({
            type: types.halfLoad,
            payload: {
                parentId,
                objective,
                data: details
            }
        })
    }
}

export const handleSwitchPosition = (id, position, type, parentId) => {
    return async (dispatch) => {
        await serverRequest('RouteDetails', null, { id, position, type, extraUrl: `switchPosition` }, 'POST')
        dispatch(halfload('details', parentId))
    }
}

export const handleCheckRows = (name, value, checked = true, type = 'check') => ({
    type: types.checkRows,
    payload: { name, value, checked, type }
}) 
